export const FILTER_DASHBOARD = "FILTER_DASHBOARD";
export const TOGGLE_ACCORDION = "TOGGLE_ACCORDION";
